<template>
  <div>
    <!-- MY PROFILE   -->
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-4">
        <b-card class="card-profile">
          <template #header>
            <h5 class="mt-2 mb-0 text-center text-muted"><strong><i class="ti-user mr-2" aria-hidden="true"></i>MY PROFILE</strong></h5>
          </template>
          <div class="mt-1 text-center">
            <b-img class="img-responsive shadow" thumbnail rounded fluid width="150" height="150" v-bind:src="`${urlPic}`" ></b-img>
            <!-- <b-img class="img-responsive" thumbnail fluid blank blank-color="#ccc"  width="200" alt="Image 1"></b-img> -->
          </div>
          <b-card-text v-if="dataProfile.length != 0" class="ml-3 mr-3 mb-5">
            <!-- <p class="mt-3 mb-0 text-muted font-style-1 f-s-1"><i>Infomation Detail</i></p> -->
            <!-- <small class="text-muted font-style-1">Name</small> -->
            <span class="text-center mt-4">
              <h4 style="color:#4e4376;" class="mb-1">
                {{ chkBlankData(dataProfile[0].title.name_eng) }} {{ chkBlankData(dataProfile[0].name) }} {{ chkBlankData(dataProfile[0].surname) }}
              </h4>
              <p class="text-muted f-s-2 mt-1 mb-0">
                <span class="font-thai">{{ chkBlankData(dataProfile[0].title.name_thai) }} {{ chkBlankData(dataProfile[0].name_thai) }} {{ chkBlankData(dataProfile[0].surname_thai) }}</span>
              </p>
            </span>
            <!-- <hr class="mt-2 mb-2"> -->
            <h5 class="font-style-1 mt-3 mb-0">ID : {{ chkBlankData(dataProfile[0].id) }}</h5>
            <!-- <hr class="mt-2 mb-2"> -->
            <h5 class="font-style-1 mt-1 mb-0">Time start working : <span class="text-success">{{ chkBlankData(dataProfile[0].time_start_working) }}</span></h5>
            <small class="font-style-1">Status : <span class="text-lowercase">{{ dataProfile[0].status.name_eng }}</span></small>
            <!-- <hr class="mt-2 mb-2"> -->
            <p class="mt-3"></p>
            <small class="text-muted font-style-1">Position</small>
            <p class="font-style-1 f-s-2 mt-1 mb-1">
              {{ chkBlankData(dataProfile[0].position) }}
            </p>
            <p class="text-muted f-s-2 mt-1 mb-0">
              <span class="font-thai">{{ chkBlankData(dataProfile[0].position_thai) }}</span>
            </p>
            <!-- <hr class="mt-2 mb-2"> -->
            <p class="mt-3"></p>
            <small class="text-muted font-style-1">Contract Type</small>
            <p class="font-style-1 f-s-2 mt-1 mb-1">
              {{ chkBlankData(dataProfile[0].contract.name_eng) }}
            </p>
            <p class="text-muted f-s-2 mt-1 mb-0">
              <span class="font-thai">{{ dataProfile[0].contract.name_thai }}</span>
            </p>
            <!-- <hr class="mt-2 mb-2"> -->
            <p class="mt-3"></p>
            <small class="text-muted font-style-1">Work start date</small>
            <p class="font-style-1 f-s-2 mt-1 mb-0">
              {{ moment(dataProfile[0].worked).format('LL') }}
            </p>
            <!-- <hr class="mt-2 mb-2"> -->
            <small class="text-muted font-style-1">Worked</small>
            <p class="font-style-1 f-s-2 mt-1 mb-0">
              {{ workYear }} Year {{ workMonth }} Month {{ workDay }} Days
            </p>
          </b-card-text>
          <small v-if="dataProfile.length != 0" class="font-style-1 text-muted float-right">Infomation Update : {{ moment(dataProfile[0].updated_at).format('MMM Do YY, h:mm:ss a') }} </small>
          <!-- <template #footer><em></em></template> -->
        </b-card>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-7 col-lg-7 col-xl-7">
        <b-tabs class="mt-5" v-if="dataProfile.length != 0" content-class="mt-3 ml-2 mr-2">
          <b-tab class="font-style-1" active>
            <template v-slot:title >
              <h5 class="f-bold mt-1 mb-1 text-dark"><i class="fa fa-folder mr-2" aria-hidden="true"></i>Detail</h5>
            </template>
            <div class="d-flex justify-content-between align-items-center">
              <h6 class="font-style-1 f-bold mt-4 mb-3 text-dark"><i class="fa fa-chevron-circle-right mr-1" aria-hidden="true"></i>GENERAL</h6>
              <b-button class="font-style-1 text-capitalize" size="sm" v-b-toggle.accordion-1 variant="info">View</b-button>
            </div>
            <!-- <hr class="mt-2 mb-2"> -->
            <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
              <b-card class="bg-custom">
                <b-card-text>
                  <small class="text-muted font-style-1">Account</small>
                  <p class="ml-3 font-style-1 f-s-2 mt-1 mb-0">
                    MUIC : {{ chkBlankData(dataProfile[0].muic_account) }}<i id="popover-1" class="fa fa-info-circle ml-1 align-top L-smallIcon" aria-hidden="true"></i>
                    <b-popover custom-class="popover-custom" placement="right" target="popover-1" triggers="hover focus">
                        <template v-slot:title></template>
                        <ul class="mt-2">
                          <li class="L-info">
                            สำหรับเข้าใช้งาน ระบบสารสนเทศภายใน ( IN HOUSE SYSTEM )
                          </li>
                          <li class="L-info">สำหรับเข้าใช้งาน @MUIC-WiFi</li>
                          <li class="L-info">สำหรับเข้าใช้งาน ระบบ SKY</li>
                        </ul>
                    </b-popover>
                  </p>
                  <p class="ml-3 font-style-1 f-s-2 mt-1 mb-0">
                    E-mail : {{ chkBlankData(dataProfile[0].email) }}
                  </p>
                  <p class="mt-3"></p>
                  <small class="text-muted font-style-1">Nickname</small>
                  <p class="ml-3 font-style-1 f-s-2 mt-1 mb-0">
                    {{ chkBlankData(dataProfile[0].nickname) }}
                  </p>
                  <p class="ml-3 font-thai f-s-22 mt-0 mb-0 text-muted">
                    {{ chkBlankData(dataProfile[0].nickname_thai) }}
                  </p>
                  <p class="mt-3"></p>
                  <small class="text-muted font-style-1">Gender</small>
                  <span v-if="chkBlankData(dataProfile[0].title.name_eng.name_eng) === '-'">-</span>
                  <span v-else>
                    <p class="ml-3 font-style-1 f-s-2 mt-1 mb-0">
                      <span v-if="dataProfile[0].gender === '1'">Male</span>
                      <span v-else-if="dataProfile[0].gender === '2'">Female</span>
                      <span v-else>-</span>
                    </p>
                    <p class="ml-3 font-thai f-s-22 mt-0 mb-0 text-muted">
                      <span v-if="dataProfile[0].gender === '1'">เพศชาย</span>
                      <span v-else-if="dataProfile[0].gender === '2'">เพศหญิง</span>
                      <span v-else>-</span>
                    </p>
                  </span>
                  <p class="mt-3"></p>
                  <small class="text-muted font-style-1">Degree</small>
                  <p class="ml-3 font-style-1 f-s-2 mt-1 mb-0">
                    {{ chkBlankData(dataProfile[0].degree.name_eng) }}
                  </p>
                  <p class="ml-3 font-thai f-s-22 mt-0 mb-0 text-muted">
                    {{ chkBlankData(dataProfile[0].degree.name_thai) }}
                  </p>
                  <p class="mt-3"></p>
                  <small class="text-muted font-style-1">Nationality</small>
                  <p class="ml-3 font-style-1 f-s-2 mt-1 mb-0">{{ dataProfile[0].nationality === '1' ? 'Thai' : 'Other' }}</p>
                  <p class="ml-3 font-thai f-s-22 mt-0 mb-0 text-muted">{{ dataProfile[0].nationality === '1' ? 'ไทย' : 'อื่นๆ' }}</p>
                </b-card-text>
              </b-card>
            </b-collapse>
            <div class="d-flex justify-content-between align-items-center">
              <h6 class="font-style-1 f-900 mt-4 mb-3 text-dark"><i class="fa fa-chevron-circle-right mr-1" aria-hidden="true"></i>DEPARTMENT</h6>
              <b-button class="font-style-1 text-capitalize" size="sm" v-b-toggle.accordion-2 variant="info">View</b-button>
            </div>
            <!-- <hr class="mt-2 mb-2"> -->
            <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
              <b-card class="bg-custom">
                <b-card-text>
                  <small class="text-muted font-style-1">Staff Group</small>
                  <p class="ml-3 font-style-1 f-s-2 mt-1 mb-0">{{ chkBlankData(dataProfile[0].group.name_eng) }}</p>
                  <p class="ml-3 font-thai f-s-22 mt-0 mb-0 text-muted">{{ chkBlankData(dataProfile[0].group.name_thai) }}</p>
                  <p class="mt-3"></p>
                  <small class="text-muted font-style-1">Staff Type</small>
                  <p class="ml-3 font-style-1 f-s-2 mt-1 mb-0">{{ chkBlankData(dataProfile[0].user_type.name_eng) }}</p>
                  <p class="ml-3 font-thai f-s-22 mt-0 mb-0 text-muted">{{ chkBlankData(dataProfile[0].user_type.name_thai) }}</p>
                  <p class="mt-3"></p>
                  <small class="text-muted font-style-1">Department</small>
                  <p class="ml-3 font-style-1 f-s-2 mt-1 mb-0">{{ chkBlankData(dataProfile[0].department.name_eng) }}</p>
                  <p class="ml-3 font-thai f-s-22 mt-0 mb-0 text-muted">{{ chkBlankData(dataProfile[0].department.name_thai) }}</p>
                  <p class="mt-3"></p>
                  <small class="text-muted font-style-1">Academic</small>
                  <p class="ml-3 font-style-1 f-s-2 mt-1 mb-0"></p>
                  <p class="ml-3 font-thai f-s-2 mt-0 mb-0"></p>
                  <p class="mt-3"></p>
                  <small class="text-muted font-style-1">Academic Detail</small>
                  <p class="ml-3 font-style-1 f-s-2 mt-1 mb-0"></p>
                  <p class="ml-3 font-thai f-s-2 mt-0 mb-0"></p>
                </b-card-text>
              </b-card>
            </b-collapse>
            <div class="d-flex justify-content-between align-items-center">
              <h6 class="font-style-1 f-900 mt-4 mb-3 text-dark"><i class="fa fa-chevron-circle-right mr-1" aria-hidden="true"></i>OTHER</h6>
              <b-button class="font-style-1 text-capitalize" size="sm" v-b-toggle.accordion-3 variant="info">View</b-button>
            </div>
            <!-- <hr class="mt-2 mb-2"> -->
            <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
              <b-card class="bg-custom">
                <b-card-text>
                  <small class="text-muted font-style-1">Host</small>
                  <p class="ml-3 font-thai f-s-2 mt-1 mb-0">{{ chkBlankData(dataProfile[0].top_department) }}</p>
                  <p class="mt-3"></p>
                  <small class="text-muted font-style-1">Mail Group</small>
                  <p class="ml-3 font-style-1 f-s-2 mt-1 mb-0">{{ chkBlankData(dataProfile[0].groupmail) }}</p>
                  <p class="mt-3"></p>
                  <small class="text-muted font-style-1">Tel Office</small>
                  <p class="ml-3 font-style-1 f-s-2 mt-1 mb-0">{{ chkBlankData(dataProfile[0].telephone) }}</p>
                  <p class="mt-3"></p>
                  <small class="text-muted font-style-1">Room</small>
                  <p class="ml-3 font-style-1 f-s-2 mt-1 mb-0">{{ chkBlankData(dataProfile[0].room) }}</p>
                </b-card-text>
              </b-card>
            </b-collapse>
          </b-tab>
          <b-tab v-if="viewManage || viewChief" >
            <template v-slot:title>
              <h5 class="f-bold mt-1 mb-1 text-dark"><i class="fa fa-diamond mr-2" aria-hidden="true"></i>Executive</h5>
            </template>
            <div v-if="viewChief">
              <h6 class="font-style-1 f-900 mt-4 mb-3 text-dark"><i class="fa fa-chevron-circle-right mr-1" aria-hidden="true"></i>CHIEF</h6>
              <b-card class="bg-custom">
                <b-card-text>
                  <small class="text-muted font-style-1">Position</small>
                  <p class="ml-3 font-style-1 f-s-2 mt-3 mb-0">{{ chkBlankData(dataProfileChief[0].position) }}</p>
                  <p class="ml-3 font-thai f-s-22 mt-0 mb-1 text-muted">{{ chkBlankData(dataProfileChief[0].position_thai) }}</p>
                  <hr>
                  <small class="ml-3 text-muted font-style-1">Update : {{ moment(dataProfileChief[0].updated_at).format('MMM Do YY, h:mm:ss a') }}</small>
                </b-card-text>
              </b-card>
            </div>
            <div v-if="viewManage">
              <h6 class="font-style-1 f-900 mt-4 mb-3 text-dark"><i class="fa fa-chevron-circle-right mr-1" aria-hidden="true"></i>MANAGEMENT</h6>
              <b-card class="bg-custom">
                <b-card-text>
                  <small class="text-muted font-style-1">Position</small>
                  <p class="ml-3 font-style-1 f-s-2 mt-3 mb-0">{{ chkBlankData(dataProfileManage[0].management) }}</p>
                  <p class="ml-3 font-thai f-s-22 mt-0 mb-1 text-muted">{{ chkBlankData(dataProfileManage[0].management_thai) }}</p>
                  <hr>
                  <small class="ml-3 text-muted font-style-1">Update : {{ moment(dataProfileManage[0].updated_at).format('MMM Do YY, h:mm:ss a') }}</small>
                </b-card-text>
              </b-card>
            </div>
          </b-tab>
          <!-- 
            <b-tab disabled>
              <template v-slot:title >
                <h5 class="f-bold mt-1 mb-1 text-muted">Emergency</h5>
              </template>
            </b-tab>
            <b-tab disabled>
              <template v-slot:title >
                <h5 class="f-bold mt-1 mb-1 text-muted">Activity</h5>
              </template>
            </b-tab> 
          -->
        </b-tabs>
      </div>
    </div>
    <!-- <pre>{{ dataProfile }}</pre> -->
    <!-- <pre>{{ dataProfileChief }}</pre> -->
    <!-- <pre>{{ dataProfileManage }}</pre> -->
  </div>
</template>

<script>
  export default {
    data(){
      return{
        dataProfile:[],
        dataProfileChief:[],
        viewChief:false,
        dataProfileManage:[],
        viewManage:false,
        workYear:0,
        workMonth:0,
        workDay:0,
        urlPic:'',
      }
    },
    mounted(){
        this.CallProfileBase()
        this.CallProfileChief()
        this.CallProfileManage()
    },
    methods: {
      async CallProfileBase(){
        this.dataProfile = []
        try {
          const res = await this.$http.get(`/staff/profile/me/`)
          if(res.status === 200){
            this.dataProfile.push(res.data)
            this.urlPic = 'https://icapp.muic.mahidol.ac.th/source/pic/'+res.data.id+'.jpg'
            this.diffDayWorked(res.data.worked)
          }
        } catch (error) {}
      },
      isEmpty(obj) {
        for(var key in obj) {
          if(obj.hasOwnProperty(key))
            return false;
        }
        return true;
      },
      async CallProfileChief(){
        this.dataProfileChief = []
        try {
          const res = await this.$http.get(`/staff/profile/chief/`)
          if(res.status === 200){
            if(this.isEmpty(res.data)){
              this.viewChief = false
            }else{
              this.viewChief = true
              this.dataProfileChief.push(res.data)
            }
          }
        } catch (error) {}
      },
      async CallProfileManage(){
        this.dataProfileManage = []
        try {
          const res = await this.$http.get(`/staff/profile/management/`)
          if(res.status === 200){
            if(this.isEmpty(res.data)){
              this.viewManage = false
            }else{
              this.viewManage = true
              this.dataProfileManage.push(res.data)
            }
          }
        } catch (error) {}
      },
      chkBlankData(val){
        return val !== null && val !== 'null' && val !== "" ? val : '-'
      },
      diffDayWorked(starDate){
        const startx = this.moment(starDate);
        const endx = this.moment(); 
        const diffx = endx.diff(startx);
        const result = this.moment.duration(diffx, 'milliseconds');
        // console.log(result)
        this.workYear = result._data.years
        this.workMonth = result._data.months
        this.workDay = result._data.days
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import url('https://fonts.googleapis.com/css2?family=Balsamiq+Sans&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Nunito:wght@600&display=swap');
  .font-style-1{ font-family: 'Nunito', sans-serif; }
  .font-style-2{ font-family: 'Rubik', sans-serif; }
  .f-900{ font-weight: 900; }
  .f-bold{ font-weight: bold; }
  .f-s-1{ font-size: 1rem; font-weight: 500; }
  .f-s-2{ font-size: 1rem; }
  .f-s-22{ font-size: 0.95rem; }
  .font-thai{ font-family: 'Kanit', sans-serif; font-weight: 100; }
  .card-profile{
    /* Add shadows to create the "card" effect */
    box-shadow: 0 4px 5px 0 rgba(0,0,0,0.2);
    transition: 0.3s;
    border-radius: 7px;
  }
  .popover-custom {
    border-radius: 10px;
    background-color:#def1ff;
    border: 1px solid #def1ff;
  }
  .L-smallIcon{ font-size: 0.95rem; color: #3e8bff; }
  .L-info{ font-family: 'Kanit', sans-serif; font-weight: 100; font-size: 0.95rem; }
  .bg-custom{ background-color: #f9f7ff; }
</style>